// src/utils/gauge.js
// Libellé du contrôle de configuration de la jauge (calculé par le serveur, backend/utils/gauge.js).
// → { texte, detail, ton } ; ton ∈ 'ok' | 'alerte' | 'neutre'.
const fmt = n => Number(n).toLocaleString('fr-FR');

export function libelleJauge(j) {
  if (!j) return null;
  let r;
  switch (j.statut) {
    // Le contrôle porte sur le 1er daily après boot (capacité PARAMÉTRÉE). Le dire, sinon
    // « Conforme — 5 140 » se lit comme la capacité actuelle alors que la jauge a pu apprendre
    // 5 581 depuis (…7632, 01/10).
    case 'ok':
      r = { ton: 'ok', texte: 'Configuration conforme',
            detail: `${fmt(j.fullcap)} mA·h au 1er rapport après démarrage, profil ${j.profil} : ${fmt(j.attendu)} mA·h attendus` };
      break;
    // Hors ±2 % mais dans [80 %, 130 %] : valeur APPRISE (redémarrage sans POR, ou daily après
    // une charge complète). Normal, pas une non-conformité (agent firmware, 01/10).
    case 'appris':
      r = { ton: 'ok', texte: 'Capacité apprise, dans les bornes',
            detail: `${fmt(j.fullcap)} mA·h au 1er rapport après démarrage (pas de remise à zéro de la jauge), profil ${j.profil} : ${fmt(j.attendu)} mA·h` };
      break;
    case 'ecart':
      r = { ton: 'alerte', texte: `Mal configurée — ${fmt(j.fullcap)} mA·h au démarrage`,
            detail: `profil ${j.profil} : ${fmt(j.attendu)} mA·h attendus (écart ${j.ecart_pct > 0 ? '+' : ''}${String(j.ecart_pct).replace('.', ',')} %, bornes 80–130 %)` };
      break;
    case 'nulle':
      r = { ton: 'alerte', texte: 'Mal configurée — capacité nulle',
            detail: `profil ${j.profil} : ${fmt(j.attendu)} mA·h attendus` };
      break;
    case 'en_attente':
      r = { ton: 'neutre', texte: 'À vérifier au prochain rapport quotidien',
            detail: `profil ${j.profil} : ${fmt(j.attendu)} mA·h attendus` };
      break;
    case 'profil_inconnu':
      r = { ton: 'alerte', texte: `Profil ${j.profil} inconnu du serveur`, detail: 'capacité attendue non définie' };
      break;
    default:
      r = { ton: 'neutre', texte: 'Non vérifiable', detail: 'profil batterie pas encore rapporté (publié au démarrage)' };
  }
  // Capacité apprise depuis le démarrage : information, pas verdict — sauf hors [80 %, 130 %].
  // Pas de « +8,6 % » affiché : le profil est un MINIMUM garanti, être au-dessus est la norme.
  if (j.fullcap_actuel != null && j.attendu && j.fullcap != null && j.fullcap_actuel !== j.fullcap) {
    r = { ...r, detail: `${r.detail} · capacité apprise depuis : ${fmt(j.fullcap_actuel)} mA·h` };
  }
  if (j.actuel_hors_bornes) {
    r = { ...r, ton: 'alerte', texte: 'Capacité apprise anormale',
          detail: `${r.detail} · hors des bornes 80–130 % du profil (${fmt(j.attendu)} mA·h)` };
  }
  if (j.dq_bloque) {
    r = { ...r, ton: 'alerte',
          detail: `${r.detail} · aucun échange de charge mesuré sur les derniers rapports : la jauge ne se configure pas` };
  }
  return r;
}
